module.exports = __webpack_public_path__ + "static/media/bike.dd7eb299.jpg";